import { Component, input, output, OnDestroy, OnInit } from '@angular/core';
import { concat, Observable, of, Subject } from 'rxjs';
import { catchError, distinctUntilChanged, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { HttpService } from 'src/app/services/http.service';
import { ControlPoint } from '../../bo/controlPoint';
import { EPSG } from '../../bo/epsg';
import { Site } from '../../bo/site';
import { Coordinate } from 'src/app/bo/coordinate';
import { CoordinateTransform } from 'src/app/bo/coordinateTransform';


@Component({
  selector: 'app-epsg-modale',
  templateUrl: './epsg-modale.component.html',
  styleUrls: ['./epsg-modale.component.scss'],
  standalone: false
})
export class EpsgModaleComponent implements OnInit, OnDestroy {
  epsgSite = output<string>();
  epsgCoordinates = output<CoordinateTransform>();
  epsgModif = output<boolean>();
  // epsgCoordinatesModif = output<boolean>();
  coordX = output<any>();
  coordY = output<any>();
  coordZ = output<any>();
  invalide = output<any>();

  mySite = input<Site>();
  isSite = input<boolean>();
  myControlPoint = input<ControlPoint>();
  newTransformCoordinate = input<Coordinate>();

  epsgSelectionneSite: EPSG;
  epsgSelectionneCoordinates: EPSG;
  epsgSelectionneCoordinatesControlPoint: EPSG;
  lastEpsgCoordinates: EPSG;

  xAffiche: number;
  yAffiche: number;
  zAffiche: number;

  input$ = new Subject<string>();
  tabEPSG$: Observable<EPSG[]>;
  epsgLoading = false;
  unsubscribe$ = new Subject<void>();
  coordXInvalide = false;
  coordYInvalide = false;
  coordZInvalide = false;
  libelleX = "EPSG.X";
  libelleY = "EPSG.Y";
  uniteExiste = false;
  
  private readonly url: string = "Sites/checkEPSG/";
  
  constructor(private readonly http: HttpService) { }

  ngOnChanges(){
   if(this.newTransformCoordinate() != undefined && !this.epsgSelectionneCoordinates.value){
    this.http.getWithParams<EPSG[]>(this.url, {epsg: this.epsgSelectionneCoordinates.value})
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(
      (result) => {
        this.tradUnite(this.lastEpsgCoordinates);
        this.coordY.emit(this.yAffiche);
        this.coordX.emit(this.xAffiche);
      });

    this.xAffiche = this.newTransformCoordinate().coordX;
    this.yAffiche = this.newTransformCoordinate().coordY;
   }
  }


  ngOnInit(): void {
    if (this.mySite().epsg != null) {
      this.http.getWithParams<EPSG[]>(this.url, { epsg : this.mySite().epsg })
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (result) => {
            this.epsgSelectionneSite = result[0];
            this.epsgSelectionneCoordinatesControlPoint = result[0];
            this.lastEpsgCoordinates = result[0];
            this.tradUnite(this.epsgSelectionneSite);
          });
      if (this.isSite()) {
        this.xAffiche = this.mySite().coordX;
        this.yAffiche = this.mySite().coordY;
      } else if (this.myControlPoint() != null) {
        this.xAffiche = this.myControlPoint().x;
        this.yAffiche = this.myControlPoint().y;
        this.zAffiche = this.myControlPoint().z;
      }
    }

    this.loadEPSG();
  }

  tradUnite(epsg: EPSG) {
    if (epsg) {
      if (epsg.unite == "") {
        this.uniteExiste = false;
        this.libelleX = "EPSG.X";
        this.libelleY = "EPSG.Y";
      }
      else if (epsg.unite.includes("metre")) {
        this.uniteExiste = true;
        epsg.unite = "EPSG.METRE";
        this.libelleX = "EPSG.X";
        this.libelleY = "EPSG.Y";
      }
      else if (epsg.unite.includes("degree")) {
        this.uniteExiste = true;
        epsg.unite = "EPSG.DEGRE";
        this.libelleX = "EPSG.LONG";
        this.libelleY = "EPSG.LAT";
      }
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  loadEPSG() {
    this.tabEPSG$ = concat(
      of([]),
      this.input$.pipe(
        distinctUntilChanged(),
        tap(() => this.epsgLoading = true),
        switchMap(term => {
          return this.checkEPSG(term).pipe(
            catchError(() => of([])),
            tap(() => {
              this.epsgLoading = false;
              this.tradUnite(this.epsgSelectionneSite);
            })
          )
        })
      )
    );
  }

  checkEPSG(epsg: string): Observable<EPSG[]> {
    if(!epsg || epsg.trim() === '') {
      console.error("EPSG code is required.");
      return of([]);
    }
    return this.http.getWithParams<EPSG[]>(this.url, {epsg: epsg})
      .pipe(takeUntil(this.unsubscribe$))
      .pipe(map(result => {
        return result;
      },
        (error) => {
          console.log(error);
        }
      ))
  }

  onSelection() {
    if (this.epsgSelectionneSite != null) {
      // this.tradUnite();
      // if (this.xAffiche != null) this.onUpdateX(this.xAffiche);
      // if (this.yAffiche != null) this.onUpdateY(this.yAffiche);
      // if (!this.isSite && this.zAffiche != null) this.onUpdateZ(this.zAffiche);
      this.epsgSite.emit(this.epsgSelectionneSite.value);
      this.epsgModif.emit(true);
    }
  }
  onSelectionCoordinatesControlPoint() {
    if (this.epsgSelectionneCoordinatesControlPoint != null) {
      // this.tradUnite();
      // if (this.xAffiche != null) this.onUpdateX(this.xAffiche);
      // if (this.yAffiche != null) this.onUpdateY(this.yAffiche);
      // if (!this.isSite && this.zAffiche != null) this.onUpdateZ(this.zAffiche);
      this.epsgSite.emit(this.epsgSelectionneCoordinatesControlPoint.value);
      this.epsgModif.emit(true);

      this.tradUnite(this.epsgSelectionneCoordinatesControlPoint);

      if (this.xAffiche != null) this.onUpdateX(this.xAffiche);
      if (this.yAffiche != null) this.onUpdateY(this.yAffiche);
      if (!this.isSite() && this.zAffiche != null) this.onUpdateZ(this.zAffiche);

      const epsgTransform = new CoordinateTransform();
      if(this.lastEpsgCoordinates != undefined) epsgTransform.EPSGin = parseInt(this.lastEpsgCoordinates.value);
      epsgTransform.EPSGout = parseInt(this.epsgSelectionneCoordinatesControlPoint.value);

      this.epsgCoordinates.emit(epsgTransform);

      this.lastEpsgCoordinates = this.epsgSelectionneCoordinatesControlPoint;

    }
  }
  onSelectionEpsgCoordinates() {
    if (this.epsgSelectionneCoordinates != null) {

      this.tradUnite(this.epsgSelectionneSite);

      if (this.xAffiche != null) this.onUpdateX(this.xAffiche);
      if (this.yAffiche != null) this.onUpdateY(this.yAffiche);
      if (!this.isSite() && this.zAffiche != null) this.onUpdateZ(this.zAffiche);

      const epsgTransform = new CoordinateTransform();
      if(this.lastEpsgCoordinates != undefined) epsgTransform.EPSGin = parseInt(this.lastEpsgCoordinates.value);
      epsgTransform.EPSGout = parseInt(this.epsgSelectionneCoordinates.value);

      this.epsgCoordinates.emit(epsgTransform);

      this.lastEpsgCoordinates = this.epsgSelectionneCoordinates;
    }
  }

  onUpdateX(e) {
    var charTest = (/^[0-9.,-]*$/).test(e);
    if (charTest) this.coordXInvalide = false;
    else this.coordXInvalide = true;
    this.coordX.emit(e);
    this.invalide.emit(this.coordXInvalide || this.coordYInvalide || this.coordZInvalide);
  }

  onUpdateY(e) {
    var charTest = (/^[0-9.,-]*$/).test(e);
    if (charTest) this.coordYInvalide = false;
    else this.coordYInvalide = true;
    this.coordY.emit(e);
    this.invalide.emit(this.coordXInvalide || this.coordYInvalide || this.coordZInvalide);
  }

  onUpdateZ(e) {
    var charTest = (/^[0-9.,-]*$/).test(e);
    if (charTest) this.coordZInvalide = false;
    else this.coordZInvalide = true;
    this.coordZ.emit(e);
    this.invalide.emit(this.coordXInvalide || this.coordYInvalide || this.coordZInvalide);
  }
}
